'use client'
import type { PropsWithStyles } from '@morpho-org/ui-v6/types'

import { cn } from '@morpho-org/ui-v6/utils'
import { memo, type PropsWithChildren } from 'react'

export interface InnerLayoutProps extends PropsWithChildren, PropsWithStyles {
  withAside?: boolean
}

// `withAside` is part of the public API but, as in V5, it does not affect the
// container's own styling (V5 stripped it from the DOM via shouldForwardProp).
// `className` is applied to the full-width background wrapper (V5 LayoutBackground),
// e.g. the vault/market layouts pass `md:bg-card` for the page content background.
const InnerLayout = ({ children, className, style }: InnerLayoutProps) => {
  return (
    <div
      className={cn('w-full px-[var(--frame-border-size)] max-md:px-0', className)}
      style={style}
    >
      <div className="@container/content-root mx-auto mt-[var(--navbar-height)] mb-[var(--frame-border-size)] flex min-h-[calc(100vh-var(--navbar-height)-var(--frame-border-size))] max-w-[1500px] grow flex-row justify-end rounded-[20px] max-md:mt-[var(--navbar-height)] max-md:mb-0 max-md:rounded-none">
        {children}
      </div>
    </div>
  )
}
export default memo(InnerLayout)
